import { Module, VuexModule, Action, Mutation } from 'vuex-module-decorators';
import Notice, { NoticeType, NoticeResponse } from './types/Notice';
import Alert from './types/Alert';
import Dialog from './types/Dialog';

@Module({
	namespaced: true
})
export default class NoticeStore extends VuexModule {
	alerts: Alert[] = [];
	dialogs: Dialog[] = [];

	@Mutation
	addAlert(notice: Alert): void {
		this.alerts.push(notice);
	}

	@Mutation
	addDialog(notice: Dialog): void {
		this.dialogs.push(notice);
	}

	@Mutation
	removeAlert(notice: Notice): void {
		this.alerts = this.alerts.filter(alert => alert.id !== notice.id);
	}

	@Mutation
	removeDialog(notice: Notice): void {
		this.dialogs = this.dialogs.filter(dialog => dialog.id !== notice.id);
	}

	@Action
	add(notice: Notice): Promise<NoticeResponse> {
		switch (notice.getType()) {
			case NoticeType.ALERT: {
				this.context.commit('addAlert', notice);
				break;
			}
			case NoticeType.DIALOG: {
				this.context.commit('addDialog', notice);
				break;
			}
			default:
				throw new Error('Invalid notice type');
		}
		return notice.getCallback();
	}

	@Action
	remove(notice: Notice): void {
		switch (notice.getType()) {
			case NoticeType.ALERT: {
				this.context.commit('removeAlert', notice);
				break;
			}
			case NoticeType.DIALOG: {
				this.context.commit('removeDialog', notice);
				break;
			}
		}
	}

	@Action
	reset(type: NoticeType): void {
		switch (type) {
			case NoticeType.ALERT: {
				this.alerts.forEach((a) => {
					this.context.commit('removeAlert', a);
				});
				break;
			}
			case NoticeType.DIALOG: {
				this.dialogs.forEach((d) => {
					this.context.commit('removeDialog', d);
				});
				break;
			}
		}
	}
	
}